import styled from "styled-components";
import Variables from "../../../assets/styleVariables";
import { HEADER_BAR_HEIGHT } from "../../../constants/fixedStyleVariables";

export const ExpandedHeaderContainer = styled.div`
  margin-top: ${HEADER_BAR_HEIGHT}px;
  width: 100%;
`;

export const Icon = styled.i`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  cursor: pointer;
  &:before {
    margin: 0;
    font-size: 23px;
    color: ${props =>
      props.disabled
        ? Variables.colors.complementary_400
        : Variables.colors.complementary_dark};
  }
  &:hover {
    background-color: ${props =>
      props.disabled ? "" : Variables.colors.complementary_400};
  }
  &:last-child {
    margin-left: 0;
  }
`;
export const ControlsIcon = styled(Icon)`
  width: 40px;
  height: 40px;
  &:before {
    font-size: 16px;
  }
`;

export const ControlSvgIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  svg {
    width: 18px;
    height: 18px;
    path {
      fill: ${props =>
        props.disabled
          ? Variables.colors.complementary_400
          : Variables.colors.complementary_dark};
    }
  }
  &:hover {
    background-color: ${props =>
      props.disabled ? "" : Variables.colors.complementary_400};
  }
  &:last-child {
    margin-left: 0;
  }
  .no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
  }
`;

export const FirstRowTitle = styled.h1`
  font-size: ${Variables.font_sizes.x3_large};
  font-weight: ${Variables.font_weight.medium};
  color: ${Variables.colors.complementary_800};
  display: ${props => (!props.status ? "none" : "block")};
  margin: 0 0 0 16px;
  max-width: 80%;
  span {
    color: ${Variables.colors.primary_vivid};
  }
`;
export const SecondRowTitle = styled(FirstRowTitle)`
  display: block;
`;

export const FirstRowAction = styled.div`
  min-width: 100px;
  min-height: 40px;
  display: ${props => (!props.status ? "none" : "flex")};
  justify-content: flex-start;
  align-items: center;
`;
export const SecondRowAction = styled(FirstRowAction)`
  display: flex;
  margin-top: 8px;
`;

export const FirstRowControls = styled.div`
  position: absolute;
  left: 32px;
  //top: calc(50% - 24px);
  justify-content: flex-end;
  align-items: center;
  min-width: 100px;
  min-height: 40px;
  display: ${props => (!props.status ? "none" : "flex")};
`;
export const SecondRowControls = styled(FirstRowControls)`
  top: unset;
  //bottom: 10px;
  display: flex;
  left: 32px;
`;

export const FirstRow = styled.div`
  width: 100%;
  height: 64px;
  background-color: ${Variables.colors.complementary};
  ${props => {
    if (props.fixed) {
      return `
        position: fixed;
        top: 0;
        right: 0;
        border-bottom: 1px solid ${Variables.colors.complementary_400};
        z-index: 99999;
      `;
    } else {
      return ` 
        display: none;
        flex-wrap:wrap;
      `;
    }
  }};
  .back-button {
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 116px;
    margin-right: 32px;
    cursor: pointer;
    color: ${Variables.colors.complementary_700};
    &:focus,
    &:hover,
    &:visited {
      color: ${Variables.colors.complementary_700};
    }
    span {
      visibility: ${props => (props.fixed ? "hidden" : "visible")};
      font-size: ${Variables.font_sizes.x2_large};
      color: ${Variables.colors.complementary_700};
    }
  }
  .container {
    z-index: ${props => (props.fixed ? 99999 : 1)};
    max-width: 1600px;
    padding-right: 30px;
    background-color: ${Variables.colors.complementary};
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
  }
`;

export const SecondRow = styled.div`
  width: 100%;
  min-height: 30px;
  border-bottom: 1px solid ${Variables.colors.complementary_400};
  margin-bottom: 24px;
  .container-2 {
    max-width: 1600px;
    width: calc(100% - 444px);
    margin: -18px auto 0 auto;
    padding-right: 60px;
  }
  .container {
    max-width: 1600px;
    width: calc(100% - 444px);
    min-height: 60px;
    margin: 0 auto;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    padding-bottom: 16px;
    position: relative;
    padding-right: 60px;
    .back-container {
      position: absolute;
      right: -3px;
      bottom: 16px;
    }
    .description {
      color: ${Variables.colors.complementary_700};
      font-size: ${Variables.font_sizes.x2_medium};
      max-width: 500px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 8px;
      display: flex;
      align-items: center;
    }
  }
`;

export const Filler = styled.div`
  height: 74px;
  width: 100%;
`;

export const Button = styled.div`
  padding: 8px 10px;
  font-size: ${Variables.font_sizes.x_small};
  color: ${Variables.colors.complementary_dark};
  border: 1px solid ${Variables.colors.dark_black};
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: -4px;
  min-width: 120px;
  justify-content: center;
  & > .icon {
    margin-left: 4px;
    &:before {
      color: ${Variables.colors.complementary_dark};
    }
  }
  & > span {
    display: flex;
    align-items: center;
    & > .icon {
      margin-right: 4px;
      margin-bottom: 2px;
    }
  }
  &:hover {
    background-color: ${Variables.colors.complementary_400};
  }
`;
